let sentinel: WakeLockSentinel | null = null;

export async function requestWakeLock(): Promise<void> {
  try {
    sentinel = (await navigator.wakeLock?.request("screen")) ?? null;
  } catch {
    // unsupported or denied — not fatal, scoring still works
  }
}

export function releaseWakeLock(): void {
  sentinel?.release().catch(() => {});
  sentinel = null;
}

document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible" && sentinel) requestWakeLock();
});
